import React from 'react';
import XIcon from '../../utility/XIcon';

class DRHeader extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.closeButton = React.createRef();
  }

  componentDidMount = () => {
    this._isMounted = true;
    if (this.props.focus && this.closeButton.current) {
      this.closeButton.current.focus();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this._isMounted) {
      if (!prevProps.focus && this.props.focus && this.closeButton.current) {
        this.closeButton.current.focus();
      }
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  backgroundColorSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  generateYearHeader = (yearNum) => {
    return (
      <th
        onClick={() => {
          this.props.sendYearSelectedToParent(yearNum);
        }}
        className="degree-requirements-content-header"
      >
        {`Year ${yearNum}`}
        <div
          className="secondary-underline"
          style={
            this.props.yearSelected === yearNum
              ? this.backgroundColorSecondary
              : null
          }
        />
      </th>
    );
  };

  displayModalMobileHeader = () => {
    return (
      <div className="degree-requirements-header-modal-mobile">
        <div
          ref={this.closeButton}
          role="button"
          tabIndex={0}
          className="xicon-container-mobile"
          onClick={() => {
            this.props.closeDegreeRequirements();
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.props.closeDegreeRequirements();
          }}
        >
          <XIcon color={this.props.tenant.primary} scrollToTop={false} />
        </div>
        <h1 className="degree-requirements-header-text-mobile">
          Degree Requirements Summary
        </h1>
        {this.props.showTitle ? (
          <h1 className="degree-requirements-header-text-mobile">
            {this.props.title}
          </h1>
        ) : null}
        <table className="mobile-year-table">
          <thead>
            <tr>
              {this.generateYearHeader(1)}
              {this.generateYearHeader(2)}
              {this.generateYearHeader(3)}
              {this.generateYearHeader(4)}
            </tr>
          </thead>
        </table>
      </div>
    );
  };

  displayModalDesktopHeader = () => {
    return (
      <div className="degree-requirements-header-modal">
        <div className="column">
          <h1 className="degree-requirements-header-text">
            Degree Requirements Summary
          </h1>
          {this.props.showTitle ? (
            <h1 className="degree-requirements-header-title">
              {this.props.title}
            </h1>
          ) : null}
        </div>
        <button
          type="button"
          onClick={() => {
            this.props.closeDegreeRequirements();
          }}
          ref={this.closeButton}
          tabIndex={0}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.props.closeDegreeRequirements();
          }}
          className="degree-requirements-close"
          style={this.colorPrimary}
        >
          Close
          <div className="xicon-container">
            <XIcon color={this.props.tenant.primary} scrollIntoView={false} />
          </div>
        </button>
      </div>
    );
  };

  render = () => {
    if (this.props.type === 'modal') {
      return this.props.isMobile
        ? this.displayModalMobileHeader()
        : this.displayModalDesktopHeader();
    }
  };
}

export default DRHeader;
